import React from 'react';

interface PageLoaderProps {
  message?: string;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ message = 'Loading...' }) => (
  <div className="loading-screen">
    <div className="loading-spinner"></div>
    <p>{message}</p>
  </div>
);
